import { Link } from 'react-router-dom'
import { ParceirosAppShell } from './ParceirosAppShell'
import { ParceirosPremioCard } from './ParceirosPremioCard'
import { PARCEIROS_ACCENT } from './parceirosBrand'
import { PARCEIROS_FINANCEIRO_PATH, PARCEIROS_INDICACOES_PATH } from './parceirosNav'
import { parceirosLeadMetrics } from './parceirosLeadMetrics'
import { useParceirosLeads } from './useParceirosLeads'

export default function ParceirosHome() {
  const { rows, total, byStatus, error, loading } = useParceirosLeads(1)
  const metrics = parceirosLeadMetrics(total, byStatus)
  const enviadas = metrics[0]?.value ?? 0
  const emAndamento = metrics[1]?.value ?? 0
  const fechadas = metrics[2]?.value ?? 0

  return (
    <ParceirosAppShell title='Dashboard'>
      <div className='grid gap-6'>
        {error && <p className='text-sm text-red-300'>{error}</p>}

        <ParceirosPremioCard rows={rows} loading={loading} />

        <div className='grid gap-3 sm:grid-cols-3'>
          <article className='rounded-2xl border border-[var(--glass-border)] bg-[var(--bg-card)] p-4'>
            <p className='text-2xl font-bold text-text-primary'>{loading ? '—' : enviadas}</p>
            <p className='mt-1 text-sm text-text-muted'>Indicações enviadas</p>
          </article>
          <article className='rounded-2xl border border-[var(--glass-border)] bg-[var(--bg-card)] p-4'>
            <p className='text-2xl font-bold text-text-primary'>{loading ? '—' : emAndamento}</p>
            <p className='mt-1 text-sm text-text-muted'>Em andamento</p>
          </article>
          <article className='rounded-2xl border border-[var(--glass-border)] bg-[var(--bg-card)] p-4'>
            <p className='text-2xl font-bold text-text-primary'>{loading ? '—' : fechadas}</p>
            <p className='mt-1 text-sm text-text-muted'>Fechadas</p>
          </article>
        </div>

        <div className='flex flex-wrap gap-3'>
          <Link
            to={PARCEIROS_INDICACOES_PATH}
            className='rounded-full px-4 py-2 text-sm font-medium text-white active:scale-95'
            style={{ background: PARCEIROS_ACCENT }}
          >
            Ver indicações
          </Link>
          <Link
            to={PARCEIROS_FINANCEIRO_PATH}
            className='rounded-full border border-[var(--glass-border)] px-4 py-2 text-sm text-text-muted hover:text-text-primary'
          >
            Ver comissões
          </Link>
        </div>
      </div>
    </ParceirosAppShell>
  )
}
